import Core from 'core/js/pages/planner/direction-internal-result/index'
import NewSearchDirectionsForm from 'js/pages/planner/direction-internal-result/_new-search-directions-form'
import PlannerMap from 'js/pages/planner/direction-internal-result/_planner-map'

export default {
  name: 'planner-results-index-cust-vl',
  extends: Core,
  template: Core.template,
  components: {
    ...Core.components,
    PlannerMap,
    NewSearchDirectionsForm
  }
}
